<div
  class="text-center spinner-container"
  [style.left]="leftMargin"
  [style.right]="rightMargin"
  [style.bottom]="bottomMargin"
  *ngIf="showFetch"
>
  <div [style.backgroundColor]="backgroundColor" class="fetch-spinner"></div>
  <h2 class="fetch-info">{{ loadingMessage }}</h2>
</div>
